import { ControlSetValueOptions } from '../models/control-set-value-options';

export const DEFAULT_CONTROL_SET_VALUE_OPTIONS: ControlSetValueOptions = {
  onlySelf: false,
  emitEvent: true,
  emitModelToViewChange: true,
  emitViewToModelChange: true
};
